import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const EstimatedValueIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4168 0H10.8359C10.4005 0 9.79207 0.252205 9.48448 0.559565L0.462048 9.58195C-0.154016 10.1973 -0.154016 11.2062 0.462048 11.8209L7.17998 18.5386C7.79465 19.1539 8.80259 19.1539 9.41819 18.5379L18.4406 9.51687C18.7479 9.20956 19.0002 8.60013 19.0002 8.16571V1.58342C19.0002 0.712734 18.2874 0 17.4168 0ZM14.2499 6.33343C13.3754 6.33343 12.6665 5.62376 12.6665 4.75002C12.6665 3.87483 13.3754 3.1666 14.2499 3.1666C15.1244 3.1666 15.8335 3.87483 15.8335 4.75002C15.8336 5.62376 15.1244 6.33343 14.2499 6.33343Z"
        fill="currentColor"
      />
    </svg>
  )
})

EstimatedValueIcon.displayName = 'EstimatedValueIcon'
